<script>
import { mapState ,mapActions } from "vuex";
import Paginador from "@/components/layout/Paginador.vue";
import Loading from "@/components/layout/Loading.vue";
import IconGalerias from "@/assets/img/icon/section/IconGalerias.vue";

export default {
    name: "GaleriaAlbumSingle",
    components: {
      Loading,
      Paginador,
      IconGalerias
    },
    data() {
        return {
            titulo: "",
            //imagenes: [],
            imagenesArr: [],
            currentYear: "",
            currentMonth: "",
            usuario_actual: this.$ls.get("user").id_usuario,

            //FF
            imagen: "",
            heightWindow: 0,
            pagina_actual: 1,
            loading: true,
            id_modulo:"6"
        };
    },
    computed: {
      ...mapState("GaleriaModule", ["galeria", "paginasGalerias", "imagenes"]),
    },
    async created(){
      await this.getGaleriaNow();
    },
    mounted() {
      this.windowsHeight();
      window.addEventListener('resize', this.windowsHeight);
      this.insertVistos()

    },
    methods: {
      ...mapActions("VistosModule", ["insertVisto"]),
        ...mapActions("GaleriaModule", ["getGaleria", "addLikeGaleria", "delLikeGaleria", "getImagenesGaleria"]),
        async insertVistos() {
          let data_ = {
            id_empresa: this.$ls.get("user").id_empresa_fk,
            id_usuario: this.$ls.get("user").id_usuario,
            id_modulo: this.id_modulo,
            id_objeto: this.$route.params.id_galeria
          }
          await this.insertVisto(data_);
        },
        toMonthName(monthNumber) {
            const date = new Date();
            date.setMonth(parseInt(monthNumber) - 1);
            return date.toLocaleString("es-CL", { month: "long" }).replace(/\./, "");
        },

        checkLiked(confirm_like, likes) {
          // console.log(Object.values(likes).some((like) => like.usuario.id_usuario == this.usuario_actual))
            return Object.values(likes).some((like) => like.usuario.id_usuario == this.usuario_actual);
        },
        async toggleLikeImagen(id_imagen, liked) {
            let data_ = {
              id_empresa: this.$ls.get("user").id_empresa_fk,
              id_usuario: this.$ls.get("user").id_usuario, 
              id_subobjeto: id_imagen,
              id_objeto: this.$route.params.id_galeria,
              id_modulo: "7"
            }
            //console.log("data para like galeria: ", data_);
            if(!liked){
              //console.log("dar like");
              await this.addLikeGaleria(data_);
            }
            else{
              //console.log("quitar like");
              await this.delLikeGaleria(data_);
            }
            //this.imagenes = this.galeria.imagenes;
            //this.$forceUpdate();
        },

        async getGaleriaNow(){
          this.loading = true;
          let data_ = {
            id_empresa: this.$ls.get("user").id_empresa_fk,
            id_usuario: this.$ls.get("user").id_usuario, 
            id_galeria: this.$route.params.id_galeria,
            plataforma: "1"
          }
          let data2_ = {
            id_empresa: this.$ls.get("user").id_empresa_fk,
            id_usuario: this.$ls.get("user").id_usuario, 
            id_galeria: this.$route.params.id_galeria,
            limite: "8"
          }
          let pagina = this.pagina_actual;
          await this.getGaleria(data_);
          await this.dataGaleriaInd(data2_, pagina);
          //this.imagenes = this.galeria.imagenes;
          
        },

        async dataGaleriaInd(data2_, pagina) {
          this.capturaFecha();
          this.titulo = this.galeria.titulo_galeria;
          await this.getImagenesGaleria({data2_, pagina});
          this.loading = false;
        },

        //FF
        capturaFecha() {
          this.currentMonth = parseInt(this.galeria.fecha_galeria.slice(5, -3));
          this.currentYear = parseInt(this.galeria.fecha_galeria.slice(0, -6));
        },
        capturarImg(img) {
          this.imagen = img;
        },
        windowsHeight() {
          let mediaQuery = window.matchMedia('(min-width: 992px)');
          let height = window.innerHeight;
          if (mediaQuery.matches) this.heightWindow = height -480 + "px";
          else this.heightWindow = "auto";
        },
        download(imagen) {

          //console.log("BAJAR IMAGEN: ", imagen);
          fetch(imagen.url_imagen_original)
          .then(response => response.blob())
          .then(blob => {
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            let nombre_imagen = "";
            if(imagen.url_imagen_original.includes("jpg")){
              nombre_imagen = this.titulo.concat(imagen.id_imagen,'jpeg'); 
            }else if(imagen.url_imagen_original.includes("png")){
              nombre_imagen = this.titulo.concat(imagen.id_imagen); 
            }
            
            link.setAttribute('download', nombre_imagen); // Reemplaza 'nombre_imagen.jpg' con el nombre deseado para el archivo descargado
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
          });
        },
        updatePage(page) {
          this.pagina_actual = page;
        },
    },
    watch: {
    pagina_actual() {
      this.getGaleriaNow();
      //this.loading = !this.loading;
    },
    
  },
};
</script>

<template>

  <section id="album">

    <div class="row">
      <div class="col-12 pt-3 mb-0">
        <h1 class="h1-custom font-700 mb-1 text-capitalize color-main d-flex align-items-center">
          <IconGalerias class="me-2 icon-svg-45"/>
        {{ titulo }}
        </h1>

        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link 
                to="/home"
                class="color-main"
              >
                <font-awesome-icon icon="fa-solid fa-house"></font-awesome-icon>
                Inicio
              </router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link 
                to="/galeria"
                class="color-main"
              >
                <font-awesome-icon icon="fa-solid fa-images"></font-awesome-icon>
                Galerías
              </router-link>
            </li>
            <li class="breadcrumb-item text-capitalize">
              <router-link 
                :to="`/galeria/${currentYear}/${currentMonth}`"
                class="color-main"
              >
                <font-awesome-icon icon="fa-solid fa-calendar"></font-awesome-icon>
                {{ toMonthName(currentMonth) }}
              </router-link>
            </li>
            <li class="breadcrumb-item text-capitalize active">
              {{ titulo }}             
            </li>
          </ol>
        </nav>
      </div>
    </div>

    <div class="row d-flex mt-2">
      <div class="col-12 mb-3 mb-lg-0">
        <p class="text-secondary h5-custom mb-0">
          ¡Revive nuestros mejores momentos! Descarga y dale like a tus fotos favoritas
        </p>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="border-bottom mb-3 pb-3"></div>
      </div>
    </div>

    <!---FF MENU ENTRE ALBUMS SIN PROGRAMAR-->
    <div class="row d-flex justify-content-center d-none">
      <div class="col-12 col-lg-5 mb-3 d-flex align-items-center justify-content-between">
        <a 
            href="javascript:" 
            class="h3 mb-0"
          >
          <font-awesome-icon icon="fa-solid fa-angle-left"></font-awesome-icon>
        </a>
        <h2 class="font-700 text-capitalize color-main">
          {{ titulo }} 
        </h2>
        <a 
          href="javascript:" 
          class="h3 mb-0"
        >
        <font-awesome-icon icon="fa-solid fa-angle-right"></font-awesome-icon>
        </a>
      </div>
    </div>

      <div 
        class="row over-y mb-4"
        :style="`height: ${heightWindow}`"
      >
        <Loading 
          v-if="loading"
          pixeles="200px"
        />
        
        <template v-if="!loading">
          <div
            v-for="imagen in imagenes"
            :key="imagen.id_imagen"
            class="col-12 col-lg-4 col-xl-3 mb-3"
          >
            <div class="card card-shadow rounded-4 border-0">
              <div class="card-body p-2">
                <div class="position-relative">
                  <a
                    @click="capturarImg(imagen)"
                    href="javascript:"
                    class="d-block"
                    data-bs-toggle="modal"
                    data-bs-target="#modal-img"
                  >
                    <img
                      :src="imagen.url_imagen_original"
                      class="img-h-250 rounded-4"
                      alt="Imagen"
                    />
                </a>
                </div>
                <div class="row">
                  <div class="col-12 text-end mt-2">
                    <a 
                      href="javascript:"
                      @click="toggleLikeImagen(imagen.id_imagen, checkLiked(imagen.confirm_like, imagen.likes))"
                      class="card-custom-footer-like ms-2 color-main"
                    >
                      <span 
                      v-if="imagen.confirm_like === null" 
                      key="solid-heart"
                      >
                      <font-awesome-icon icon="fa-solid fa-heart"></font-awesome-icon>
                      </span>
                      <span 
                      v-if="imagen.confirm_like !== null" 
                      key="regular-heart"
                      >
                      <font-awesome-icon icon="fa-solid fa-heart" class="color-red"></font-awesome-icon>
                      </span>
                    </a>
                    <span class="card-custom-footer-like-count ms-1 me-2">
                      {{ imagen.likes.length }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
      <Paginador
        :data="paginasGalerias"
        :page="pagina_actual"
        @updatePage="updatePage"
      />
      <!-- Modal -->
      <div 
        class="modal fade" 
        id="modal-img" 
        tabindex="-1"
      >
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header d-flex justify-content-end border-0 pb-0">
              <a 
                class="h3 mb-0 link-secondary" 
                href="javascript:"
                data-bs-dismiss="modal"
              >
              <font-awesome-icon icon="fa-solid fa-xmark"></font-awesome-icon>
              </a>
            </div>
            <div class="modal-body">
              <img 
                :src="imagen.url_imagen_original" 
                class="img-fluid"
              >
            </div>
            <div class="modal-footer">
            <button 
                type="button" 
                class="btn btn-custom btn-custom-line-gray mw-150" 
                data-bs-dismiss="modal">
                <font-awesome-icon icon="fa-solid fa-angle-left" class="pe-2"></font-awesome-icon>
                Volver
              </button>
              <a 
                @click="download(imagen)"
                class="btn btn-custom btn-custom-main mw-150">
                <font-awesome-icon icon="fa-solid fa-download" class="pe-2"></font-awesome-icon>
                Descargar
            </a>
            </div>
          </div>
        </div>
      </div>
      
  </section>

</template>